<template>
	<div>
		<Layout :back="'/'" class="bg-primary  " :navTransparent="true">
			<template slot="header">
				<h1>Registrate</h1>
				<p>Ingresá y paosdmoasm sod mi oi o oi asd mi</p>
			</template>

			<div class="main-container p-4">
				<div>
					<FormulateForm ref="form" name="register" v-model="form" @submit="save">
						<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

						<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />

						<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />

						<FormulateInput label="Contraseña" type="password" name="password" validation-name="Contraseña" validation="required" />

						<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="required|^phone" />

						<FormulateInput type="identification" label="Documento de identidad" name="document" validation-name="Documento de identidad" validation="required|documentID" />

						<FormulateInput label="Empresa" validation-name="Empresa" name="business" placeholder="Empresa" validation="required" />
						<FormulateInput label="Departamento" validation-name="Departamento" name="department" :options="departments" type="select" placeholder="Seleccionar departamento" validation="required" />
					</FormulateForm>
				</div>
			</div>
			<template slot="footer">
				<div class="w-100 p-2">
					<div class="btn btn-primary btn-lg btn-block" v-ripple @click="$formulate.submit('register')">
						<span v-if="saving">Cargando<i class="icon-loading"></i></span>
						<span v-else>Registrarme</span>
					</div>
				</div>
			</template>
		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../vue-apollo'
import { mapMutations } from 'vuex'
import Layout from '@/components/layout/Layout'
import PositionCard from '@/components/PositionCard'

export default {
	name: 'Register',
	components: {
		Layout,
		PositionCard,
	},
	data() {
		return {
			form: {
				name: null,
				lastname: null,
				phone: null,
				email: null,
				password: null,
				document: {
					type: 'UY',
					number: null,
				},
				business: null,
				department: null,
			},
			saving: false,
			departments: [
				{ value: 'montevideo', label: 'Montevideo' },
				{ value: 'artigas', label: 'Artigas' },
				{ value: 'canelones', label: 'Canelones' },
				{ value: 'cerro-largo', label: 'Cerro Largo' },
				{ value: 'colonia', label: 'Colonia' },
				{ value: 'durazno', label: 'Durazno' },
				{ value: 'flores', label: 'Flores' },
				{ value: 'florida', label: 'Florida' },
				{ value: 'lavalleja', label: 'Lavalleja' },
				{ value: 'maldonado', label: 'Maldonado' },
				{ value: 'paysandu', label: 'Paysandú' },
				{ value: 'rio-negro', label: 'Río Negro' },
				{ value: 'rivera', label: 'Rivera' },
				{ value: 'rocha', label: 'Rocha' },
				{ value: 'salto', label: 'Salto' },
				{ value: 'san-jose', label: 'San José' },
				{ value: 'soriano', label: 'Soriano' },
				{ value: 'tacuarembo', label: 'Tacuarembó' },
				{ value: 'treinta-y-tres', label: 'Treinta y tres' },
			],
		}
	},
	methods: {
		...mapMutations(['authSuccess', 'logout']),
		save() {
			if (!this.saving) {
				this.saving = true
				const data = {
					name: this.form.name,
					lastname: this.form.lastname,
					phone: this.form.phone,
					email: this.form.email,
					password: this.form.password,
					phone: this.form.phone,
					document: this.form.document,
					business: this.form.business,
					department: this.form.department,
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: SellerInput!) {
								sellerRegister(data: $data) {
									token
									seller {
										id
									}
								}
							}
						`,
						variables: {
							data,
						},
					})
					.then(({ data }) => {
						this.saving = false
						let access_token = data.sellerRegister.token
						let logged_user = data.sellerRegister.seller
						onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => {
							this.authSuccess({ token: access_token, loggedUser: logged_user })
							this.loginIn = false
							this.$router.push('/')
						})
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.saving = false
					})
			}
		},
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
	color: #fff;
}
.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}
</style>
